// extracted by mini-css-extract-plugin
export var auto = "_48-1";
export var spinner = "_48-0";